import { configureStore } from '@reduxjs/toolkit';

import { hubApi } from '@/api/hubApi';

export const store = configureStore({
    reducer: {
        [hubApi.reducerPath]: hubApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(hubApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
